import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionWeightLogUpdatePayload,
	IActionWeightLogUpdatePayloadDone,
	IActionWeightLogUpdatePayloadError,
} from './types';

export const weightLogUpdate = actionCreatorAsync<
	IActionWeightLogUpdatePayload,
	IActionWeightLogUpdatePayloadDone,
	IActionWeightLogUpdatePayloadError
>(
	'weightLogUpdate',
	async (params) => {
		const { weightLog } = params;
		const { id, ...body } = weightLog;
		const { data } = await Api.weightLog.update({
			params: { id },
			body,
		});

		return data;
	},
);
